import { ComponentChildren } from 'preact';
import { PaddingSize } from 'server/types';

type BlockWrapperProps = {
  paddingt?: PaddingSize;
  paddingb?: PaddingSize;
  bgcolor?: string;
  children: ComponentChildren;
  isEditor?: boolean;
};

export function BlockWrapper(props: BlockWrapperProps) {
  const paddingRules = {
    top: {
      xl: 'pt-32 md:pt-56',
      lg: 'pt-16 md:pt-40',
      md: 'pt-8 md:pt-20',
      sm: 'pt-4 md:pt-8',
    },
    bottom: {
      xl: 'pb-32 md:pb-56',
      lg: 'pb-16 md:pb-40',
      md: 'pb-8 md:pb-20',
      sm: 'pb-4 md:pb-8',
    },
  };

  const defaultPadding: PaddingSize = 'lg';
  const padding = `${paddingRules.top[props.paddingt || defaultPadding]} ${
    paddingRules.bottom[props.paddingb || defaultPadding]
  }`;

  return (
    <div class={`content-block-body max-w-5xl w-full mx-auto relative ${padding}`}>
      {props.children}
    </div>
  );
}
